// extracted by mini-css-extract-plugin
export default {"PageLayout":"index-module--PageLayout--20952","ScrollArea":"index-module--ScrollArea--00690"};